import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd">
      <path fill="#FA744E" d="M27.0496,10 L19.7106,10 L8.7106,32 C8.7106,32 24.4056,27.04 30.5646,15.924 C32.0366,13.266 30.0876,10 27.0496,10"/>
      <path fill="#00BFB3" d="M21.3553,0 L7.5333,0 L0.4273,14.211 C-0.9027,16.871 1.0323,20 4.0043,20 L11.3553,20 L21.3553,0 Z"/>
      <path className="euiIcon__fillNegative" d="M2.533,10 L0.428,14.211 C-0.903,16.871 1.032,20 4.005,20 L11.355,20 L16.355,10 L2.533,10 Z"/>
    </g>
  </svg>
);
